module.exports = __webpack_public_path__ + "static/media/Cross.569ad574.svg";